import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone, faLocationDot, faAngleRight } from '@fortawesome/free-solid-svg-icons';

import logo from '../assets/images/logo.png';
import '../styles/Footer.css';

export default function Footer() {
  return (
    <footer className="site-footer">

      <div className="footer-top-bar" />

      <div className="footer-main">
        <div className="footer-inner">

          {/* Brand column */}
          <div className="footer-col footer-brand">
            <Link to="/" className="footer-logo">
              <img width="527" height="504" decoding="async" loading="lazy" src={logo} alt="Surya Group" />
              <span>Surya Group</span>
            </Link>
            <p className="footer-desc">
              Your trusted partner for comprehensive building estimation and modelling services
              tailored to contractors, architects, engineers, and builders across the United States
              and North America.
            </p>
            <div className="footer-social">
              <a href="https://www.facebook.com/people/Surya-Group-Estimation/61574719572294/"
                 target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="social-icon social-fb">
                <FontAwesomeIcon icon={faFacebook} />
              </a>
              <a href="https://www.instagram.com/suryagroup.us/"
                 target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="social-icon social-ig">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://www.linkedin.com/company/suryagroupestimation"
                 target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="social-icon social-li">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </div>
          </div>

          {/* Services column */}
          <div className="footer-col">
            <h2 className="footer-heading">Our Services</h2>
            <ul className="footer-links">
              <li><Link to="/services/flooring-estimation"><FontAwesomeIcon icon={faAngleRight} />Flooring Estimation</Link></li>
              <li><Link to="/services/lumber-estimation"><FontAwesomeIcon icon={faAngleRight} />Lumber Estimation</Link></li>
              <li><Link to="/services/concrete-estimation"><FontAwesomeIcon icon={faAngleRight} />Concrete Estimation</Link></li>
              <li><Link to="/services/roofing-estimation"><FontAwesomeIcon icon={faAngleRight} />Roofing Estimation</Link></li>
              <li><Link to="/services/electrical-estimation"><FontAwesomeIcon icon={faAngleRight} />Electrical Estimation</Link></li>
              <li><Link to="/services/mep-estimation"><FontAwesomeIcon icon={faAngleRight} />MEP Estimation</Link></li>
              <li><Link to="/services/drywall-estimation"><FontAwesomeIcon icon={faAngleRight} />Drywall Estimation</Link></li>
            </ul>
          </div>

          {/* Support column */}
          <div className="footer-col">
            <h2 className="footer-heading">Support</h2>
            <ul className="footer-links">
              <li><Link to="/about"><FontAwesomeIcon icon={faAngleRight} />About Us</Link></li>
              <li><Link to="/blog"><FontAwesomeIcon icon={faAngleRight} />Blog</Link></li>
              <li><Link to="/frequently-asked-questions"><FontAwesomeIcon icon={faAngleRight} />FAQ</Link></li>
              <li><Link to="/policy#privacy_policy"><FontAwesomeIcon icon={faAngleRight} />Privacy Policy</Link></li>
              <li><Link to="/policy#terms_condition"><FontAwesomeIcon icon={faAngleRight} />Terms &amp; Conditions</Link></li>
              <li><Link to="/policy#refund_policy"><FontAwesomeIcon icon={faAngleRight} />Refund Policy</Link></li>
              <li><Link to="/policy#delivery_policy"><FontAwesomeIcon icon={faAngleRight} />Delivery Policy</Link></li>
            </ul>
          </div>

          {/* Contact column */}
          <div className="footer-col">
            <h2 className="footer-heading">Contact Us</h2>
            <ul className="footer-contact-list">
              <li>
                <span className="contact-icon"><FontAwesomeIcon icon={faEnvelope} /></span>
                <a href="mailto:Info@suryagroup.us">Info@suryagroup.us</a>
              </li>
              <li>
                <span className="contact-icon"><FontAwesomeIcon icon={faPhone} /></span>
                <a href="tel:+18163369313">+1 (816) 336-9313</a>
              </li>
              <li>
                <span className="contact-icon"><FontAwesomeIcon icon={faLocationDot} /></span>
                <span>United States &amp; North America</span>
              </li>
            </ul>
            <Link to="/contact-us" className="footer-cta">
              Get a Free Quote
            </Link>
          </div>

        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-inner">
          <p>&copy; {new Date().getFullYear()} Surya Group. All rights reserved.</p>
          <p className="footer-bottom-links">
            <Link to="/policy#privacy_policy">Privacy</Link>
            <span>·</span>
            <Link to="/policy#terms_condition">Terms</Link>
            <span>·</span>
            <Link to="/contact-us">Contact</Link>
          </p>
        </div>
      </div>

    </footer>
  );
}
